import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
/**
 * Status: *In progress*.
 *
 * A component that is used to create external reference to svg icons from the icon assets.
 * To show an icon, give the name of the icon (without file ending) and the desired color (defaults to black).
 */

const SvgIcon = (_ref) => {
  let {
    iconName,
    color,
    className,
    title
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["iconName", "color", "className", "title"]);

  return React.createElement("svg", _extends({
    className: classnames('svg-icon', {
      [className]: className,
      [`svg-icon--${color || 'black'}`]: color
    })
  }, rest), title && React.createElement("title", null, title), React.createElement("use", {
    xlinkHref: `#${iconName}`
  }));
};

SvgIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The name of the icon*/
  iconName: PropTypes.string,

  /** The color of the icon (white, black, purple or grey)*/
  color: PropTypes.oneOf(['white', 'black', 'purple', 'grey', 'light-grey']),

  /** Other class names*/
  className: PropTypes.string,
  title: PropTypes.string
} : {};
export default SvgIcon;